"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _class, _descriptor, _temp;

var MarketingOptIn = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(MarketingOptIn, _Component);

  function MarketingOptIn() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, MarketingOptIn);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(MarketingOptIn)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "profile", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      doMarketingOptIn: _this.profile.marketingOptIn
    };
    return _this;
  }

  babelHelpers.createClass(MarketingOptIn, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.profile != this.props.profile) {
        this.setState({
          doMarketingOptIn: this.props.profile.doMarketingOptIn
        });
      }
    }
  }, {
    key: "setMarketingOptIn",
    value: function setMarketingOptIn(event) {
      this.setState({
        doMarketingOptIn: event.target.checked
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        "data-field": "marketingOptIn",
        className: "form-group checkbox"
      }, _react.default.createElement("label", null, _react.default.createElement("span", {
        className: "checkbox-wrap"
      }, _react.default.createElement("input", {
        type: "checkbox",
        onChange: this.setMarketingOptIn,
        checked: this.state.doMarketingOptIn,
        value: "1"
      }), _react.default.createElement("span", null)), _react.default.createElement("span", {
        id: "marketingOptInText"
      }, this.profile.system.optInText)), _react.default.createElement("input", {
        type: "hidden",
        name: "marketingOptIn",
        id: "marketingOptIn",
        value: this.state.doMarketingOptIn ? '1' : '0'
      }));
    }
  }]);
  return MarketingOptIn;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "profile", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "setMarketingOptIn", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setMarketingOptIn"), _class.prototype)), _class);
var _default = MarketingOptIn;
exports.default = _default;